import {getMediaUrl} from "@/services/request";

const KNOWN_MEDIA_TYPES = new Set(['image', 'video', 'pdf', 'other']);

export function isVideoSrc(src = '') {
    if (src.startsWith('data:video')) {
        return true;
    }

    const clean = src.split('?')[0].split('#')[0].toLowerCase();
    return /\.(mp4|webm|ogg|ogv|m4v|mov)$/i.test(clean);
}

export function isPdfSrc(src = '') {
    const clean = src.split('?')[0].split('#')[0].toLowerCase();
    return clean.endsWith('.pdf');
}

export function inferMediaType(src = '') {
    if (isVideoSrc(src)) {
        return 'video';
    }

    if (isPdfSrc(src)) {
        return 'pdf';
    }

    return 'image';
}

export function resolveMediaSrc(src = '') {
    if (!src) {
        return '';
    }

    return getMediaUrl(src);
}

export function toPortfolioMediaList(entries = []) {
    const list = Array.isArray(entries) ? entries : [];

    return list
        .map((entry, index) => {
            const rawPath = typeof entry === 'string'
                ? entry
                : entry?.path || entry?.src || '';
            const path = String(rawPath || '').trim();

            if (!path) {
                return null;
            }

            const inferredType = inferMediaType(path);
            const rawType = typeof entry === 'string' ? inferredType : String(entry?.type || '').toLowerCase();
            const type = rawType === 'other'
                ? 'other'
                : KNOWN_MEDIA_TYPES.has(rawType) && rawType
                    ? inferredType
                    : inferredType;

            return {
                displayOrder: Number.isFinite(Number(entry?.displayOrder)) ? Number(entry.displayOrder) : index,
                path,
                src: resolveMediaSrc(path),
                type,
            };
        })
        .filter(Boolean);
}
